import React, { createContext, useState, useContext } from 'react';

const PharmacyContext = createContext();

export const usePharmacy = () => useContext(PharmacyContext);

export const PharmacyProvider = ({ children }) => {
  const [reminders, setReminders] = useState([]);
  const [refills, setRefills] = useState([]);
  const [interactions, setInteractions] = useState([]);

  return (
    <PharmacyContext.Provider value={{ reminders, setReminders, refills, setRefills, interactions, setInteractions }}>
      {children}
    </PharmacyContext.Provider>
  );
};
